import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import TrialLocked from "@/components/trial/TrialLocked";

interface AutoSendContractsToggleProps {
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
}

/**
 * Org setting for whether the approval modal offers Approve + Send Contract
 * alongside Approve.
 */
const AutoSendContractsToggle: React.FC<AutoSendContractsToggleProps> = ({
  checked,
  disabled = false,
  onCheckedChange,
}) => {
  return (
    <div className="flex items-center justify-between gap-4" data-testid="auto-send-contracts">
      <div className="space-y-0.5 pr-4">
        <Label htmlFor="auto_send_contracts_enabled">Send contract on approval</Label>
        <p className="text-xs text-muted-foreground">
          When this is on, the approval modal offers Approve + Send Contract and Approve. When it is
          off, the modal only offers Approve — the deal moves to Contract Ready and you send it
          yourself from Merchant Tasks.
        </p>
      </div>
      <TrialLocked lock="autoSendContracts" inline side="left">
        <Switch
          id="auto_send_contracts_enabled"
          checked={checked}
          disabled={disabled}
          onCheckedChange={onCheckedChange}
          aria-label="Send contract on approval"
        />
      </TrialLocked>
    </div>
  );
};

export default AutoSendContractsToggle;
